import { ConfirmDestructiveDialog } from '@/shared/components/ConfirmDestructiveDialog';

/**
 * Confirms deleting a file before the delete request is sent. Purely
 * presentational — `FileListPane` owns which file is pending deletion, decides
 * what "confirm"/"cancel" do, and passes back the request's progress and any
 * refusal, so this dialog never calls the delete mutation itself.
 */
export function DeleteFileDialog({
  fileName,
  open,
  isPending = false,
  error,
  onConfirm,
  onCancel,
}: {
  fileName: string;
  open: boolean;
  isPending?: boolean;
  error?: string | null;
  onConfirm: () => void;
  onCancel: () => void;
}) {
  return (
    <ConfirmDestructiveDialog
      open={open}
      title={<>Delete &ldquo;{fileName}&rdquo;?</>}
      confirmLabel="Delete file"
      isPending={isPending}
      error={error}
      onConfirm={onConfirm}
      onCancel={onCancel}
    >
      This will permanently delete &ldquo;{fileName}&rdquo; from this workspace.
      This cannot be undone.
    </ConfirmDestructiveDialog>
  );
}
